export const LOAD_DASHBOARD_DATA = 'dashboard/LOAD_DASHBOARD_DATA';
export const SET_DASHBOARD_STATUS = 'dashboard/SET_DASHBOARD_STATUS';